import { Pipe, PipeTransform } from '@angular/core';

import { IWorkspace } from '../../../modules/chat/interfaces/IWorkspace';

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

@Pipe({
  name: 'hyperlink',
  standalone: false,
})
export class HyperlinkPipe implements PipeTransform {
  transform(value: string, workspace: IWorkspace) {
    let replaced = value;
    if (workspace?.config?.dynamicLinks?.length) {
      for (const iterator of workspace.config.dynamicLinks) {
        const pattern = new RegExp(iterator.pattern, 'i');
        replaced = replaced.replace(pattern, (data) => {
          const href = escapeHtml(`${iterator.url ?? ''}${data.substring(1)}`);
          return `<a href='${href}' target='_blank' rel='noopener noreferrer'>${escapeHtml(data)}</a>`;
        });
      }
    }
    return replaced;
  }
}
